import { useCallback } from "react";

const useDispatchCustomEvent = () => {
  const dispatchCustomEvent = useCallback((eventType: string, payload: any) => {
    const event = new CustomEvent(eventType, { detail: payload });
    window.dispatchEvent(event);
  }, []);

  return dispatchCustomEvent;
};

export default useDispatchCustomEvent;
